class sqlServer {
    constructor(){

    }
    initOptions(){
        
    }
    /*
        功能：根据连接字串获取默认数据库
        connectString ： 连接字串
    */
    getDefaultDataBase(connectString){
        var arr = connectString.match(/Initial Catalog=([^;]*);/);
        if(arr){
            return arr[1] ? arr[1] : "";
        }
        return "";
    }
    /*
        功能：格式化sql语句
        sql ： 连接字串
    */
    FilterSQL(sql){
        return sql;
    }
}
export default new sqlServer();


// WEBPACK FOOTER //
// ./src/js/backstage/fvADOModule/lib/sqlServer.js